//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Outlet } from 'react-router';
import HelpInitializer from './HelpInitializer';
import OnboardingTourStarter from './OnboardingTourStarter';
import TourController from './tours/components/TourController';

/**
 * HelpManager - Top-level component for the help system.
 *
 * This component aggregates all help-related features:
 * - HelpInitializer: Arms the inactivity timer that pulses the Help icon.
 * - OnboardingTourStarter: Takes the help moment for the Getting Started tour
 *   on an empty server, and drives the steps of it that depend on app state.
 * - TourController: Manages guided tours when they're active.
 */
const HelpManager = () => {
  return (
    <>
      <HelpInitializer />
      <OnboardingTourStarter />
      <TourController />
      <Outlet />
    </>
  );
};

export default HelpManager;
